import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['Evitas llamadas porque te da pánico no entender', 'Dices “yes” aunque no entendiste nada', 'En tu cabeza la frase existe… pero tu boca no la suelta', 'Te obsesiona el acento y por eso hablas menos', 'Te da vergüenza pedir que repitan, como si fuera un pecado'];
  return <section className="py-20 bg-white px-4" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <div className="text-center mb-12" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-165">
            Si te pasa esto, no es “falta de inglés”
          </h2>
          <p className="text-xl text-gray-600" data-id="element-166">
            No estás sola. Y no estás rota.
          </p>
        </div>

        <div className="grid gap-4 md:gap-6" data-id="element-167">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start p-6 bg-red-50 rounded-2xl border border-red-100 hover:shadow-md transition-shadow" data-id="element-168">
              <XCircle className="w-6 h-6 text-red-500 mt-1 mr-4 flex-shrink-0" data-id="element-169" />
              <p className="text-lg text-gray-800 font-medium" data-id="element-170">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-12 text-center p-8 bg-gray-50 rounded-3xl border border-gray-200" data-id="element-171">
          <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-172">
            Estás intentando hablar con un sistema equivocado.
          </p>
        </motion.div>
      </div>
    </section>;
}